<template>
  <section id="about" class="about-me">
    <div class="about-content">
      <div class="about-text">
        <h2>{{ $t("aboutMe.title") }}</h2>
        <p v-html="$t('aboutMe.introduction')"></p>
        <p v-html="$t('aboutMe.translation')"></p>
        <p v-html="$t('aboutMe.goal')"></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutMeComponent",
};
</script>

<style scoped>
.about-me {
  padding: 40px 20px;
  text-align: left;
  max-width: 1200px;
  margin: 0 auto;
}

.about-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.profile-photo {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
}

.cv-button {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.cv-button:hover {
  background-color: #369f6e;
}

p {
  font-size: 1.2rem;
  line-height: 1.6;
  color: #555;
}

ul {
  text-align: left;
  list-style-type: disc;
  margin-left: 20px;
  margin-bottom: 15px;
}

li {
  font-size: 1rem;
  color: #555;
  margin-bottom: 5px;
}

@media (max-width: 768px) {
  h2 {
    font-size: 2rem;
  }

  p {
    font-size: 1rem;
  }
}

.dark-mode .about-me {
  color: #f0f0f0;
}

.dark-mode .about-me h2 {
  color: #f0f0f0;
}

.dark-mode .about-me p {
  color: #d0d0d0;
}

.dark-mode .about-me li {
  color: #d0d0d0;
}

.dark-mode .cv-button {
  background-color: #369f6e;
}

.dark-mode .cv-button:hover {
  background-color: #2a7f56;
}
</style>
